import React from "react";
import "assets/wm-react-menu.scss";
import "./BasePage.scss";
import PropTypes from "prop-types";
import Loading from "components/loading/Loading";
import { Header } from "components/header/Header";

function BasePage(props) {
  const { className, title, children, loading } = { ...props };

  return (
    <div className={`base-page ${className}`}>
      <Header />
      <section className="page-content">
        {title && <h1>{title}</h1>}
        {loading ? <Loading visible={true} /> : children}
      </section>
    </div>
  );
}

export default BasePage;

BasePage.defaultProps = {
  children: null,
  className: "",
  title: null,
  loading: false,
};

BasePage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
};
